// i18next initialization for the retailer language-selection feature.
// Translations are static (no API key / no network) and cover the retailer UI.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import gu from "./locales/gu.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import bn from "./locales/bn.json";
import { DEFAULT_LANGUAGE_NAME, nameToCode } from "./languages";

// The persisted canonical language name (e.g. "arabic") lives in the auth slice,
// mirrored to localStorage so we can pick the right language before React mounts.
const initialName =
  (typeof localStorage !== "undefined" && localStorage.getItem("language")) ||
  DEFAULT_LANGUAGE_NAME;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    gu: { translation: gu },
    ar: { translation: ar },
    hi: { translation: hi },
    bn: { translation: bn },
  },
  lng: nameToCode(initialName),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
